import React from "react";

import { POPUP } from "../../data/content";
import useDialog from "../general/useDialog";

const STORAGE_KEY = `estia-popup-closed-${POPUP.ID}`;

//Storage can be blocked (private browsing etc.) - then the popup just shows as normal
const wasClosedThisVisit = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === "1";
  }
  catch (e) {
    return false;
  }
};
const rememberClosed = () => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, "1");
  }
  catch (e) {
    //Ignore
  }
};

const isInDate = () => {
  if (!POPUP.SHOW_UNTIL) {
    return true;
  }
  //Show until the end of the SHOW_UNTIL day
  return new Date() <= new Date(`${POPUP.SHOW_UNTIL}T23:59:59`);
};

//Event poster that pops up shortly after the home page opens (a Wix lightbox on the old site). Clicking it opens the event page.
//Once closed it stays closed for the rest of the visit, instead of coming back every time the page loads
const EventPopup = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dialogRef = React.useRef(null);
  const closeRef = React.useRef(null);

  React.useEffect(() => {
    if (!POPUP.ENABLED || !isInDate() || wasClosedThisVisit()) {
      return undefined;
    }
    const timeout = window.setTimeout(() => {
      //Don't interrupt someone who is using the mobile menu or a photo gallery
      if (!document.querySelector("[aria-modal='true']:not([hidden])")) {
        setIsOpen(true);
      }
    }, POPUP.DELAY_MS);
    return () => window.clearTimeout(timeout);
  }, []);

  const close = React.useCallback(() => {
    rememberClosed();
    setIsOpen(false);
  }, []);

  useDialog(isOpen, close, dialogRef, closeRef);

  if (!isOpen) {
    return null;
  }

  const image = (
    <img
      src={POPUP.IMAGE}
      alt={POPUP.ALT}
      width={POPUP.WIDTH}
      height={POPUP.HEIGHT}
      className={"event-popup-image"}
    />
  );

  return (
    <div
      className={"event-popup-overlay"}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          close();
        }
      }}
    >
      <div
        ref={dialogRef}
        className={"event-popup"}
        role={"dialog"}
        aria-modal={"true"}
        aria-label={POPUP.LABEL}
        tabIndex={-1}
      >
        <button
          ref={closeRef}
          type={"button"}
          className={"event-popup-close"}
          aria-label={"Close"}
          onClick={close}
        >
          <svg
            viewBox={"0 0 24 24"}
            aria-hidden={"true"}
          >
            <path d={"M6 6l12 12M18 6L6 18"} />
          </svg>
        </button>
        {POPUP.LINK ? (
          <a
            href={POPUP.LINK}
            target={"_blank"}
            rel={"noopener noreferrer"}
            className={"event-popup-link"}
            onClick={close}
          >
            {image}
            <span className={"visually-hidden"}>{POPUP.LINK_LABEL} (opens in a new tab)</span>
          </a>
        ) : image}
      </div>
    </div>
  );
};

export default EventPopup;
